// extracted by mini-css-extract-plugin
export default {"styles":"styles___L6THI","grid1":"grid1___FurMJ","grid2":"grid2___Ln3fF"};